import { getProxiedServiceUrl, getProxiedUrl } from 'gw-portals-url-js'; 
import { JsonRPCService } from 'gw-portals-transport-js';

export default class UserService {
    static getAvailableProducerCodesForCurrentUser(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'),
            'getAvailableProducerCodesForCurrentUser', [], additionalHeaders);
    }

    static hasUserSystemPermission(permission, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'hasUserSystemPermission',
            [permission], additionalHeaders);
    }

    static hasUserPermission(permission, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'hasUserPermission',
            [permission], additionalHeaders);
    }

    static hasUserAccessToAccountPolicies(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'hasUserAccessToAccountPolicies',
            [accountNumber], additionalHeaders);
    }

    /**
     * This is the server responsible for dealing with the Gateway Current User Information
     * whic is used in the AuthenticationContext.jsx
     **/

    static getGateWayCurrentUser(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'getCurrentUser',
            [], additionalHeaders);
    }

    static getGateWayCurrentUser_RI (additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'getCurrentInsuredUser_Ext',
            [], additionalHeaders);
    }

    static getInsuredUser_RI (userID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'getInsuredUser_Ext', [userID], additionalHeaders);
    }

    static addInsuredUser_RI (insuredUser, additionalHeaders = {})  {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'addInsuredUser_Ext', [insuredUser], additionalHeaders);
    }

    static updateInsuredUser_RI (insuredUser, additionalHeaders = {})  {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'updateInsuredUser_Ext', [insuredUser], additionalHeaders);
    }
    
    static deleteInsuredUser_RI (userID, additionalHeaders = {})  {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'deleteInsuredUser_Ext', [userID], additionalHeaders);
    }
    static isValidInsuredUser_RI(userID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'), 'isValidInsuredUser_Ext', [userID], additionalHeaders);
    }
    // Fb 14847 ---
    static getPolicyHolderFormsOrderRequestForCurrentUser_RI(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'),
            'getPolicyHolderFormsOrderRequestForCurrentUser_Ext', [], additionalHeaders);
    }

    static placeOrderForPolicyHolderRepublicForms_RI(formsOrderRequestDTO, reqRepublicForms, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayUser'),
            'placeOrderForPolicyHolderRepublicForms_Ext', [formsOrderRequestDTO, reqRepublicForms], additionalHeaders);
    }
    // --- FB 4847

    // FB 17118 ----
    static getRI_UserList(authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        // return fetch(getProxiedUrl('ri-rest-services/api/ph/v1/insured-users/ri'), params).then((response) => response.json())
        const servicePath = 'ri-rest-services/api/ph/v1/insured-users/ri';
        let url = getProxiedUrl(servicePath);

        return fetch(url, params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    } 

    static addInsuredUser(user,authHeader = {}) {
        let url = getProxiedUrl('ri-rest-services/api/ph/v1/ldap-user');

        return fetch(url, {
            method: 'POST',
            headers: {
                'Authorization' : authHeader.Authorization,
                'Content-Type': 'application/json',
                "Accept": "application/json"
            },
            body: JSON.stringify(user)            
        })
        .then(response => response.json())
        .then(data => {
            return data;
        }).catch((err) => {
            
            if(_.isEmpty(err)){
                return Promise.resolve({
                    error: 'No error!'
                });                    

            }else {
                return Promise.reject({
                    error: 'Error with service'
                });
            }

        });         
    }       

    static resetPhPassword(param,authHeader = {}) {
        let url = getProxiedUrl('/account-management/resetpassword');

        return fetch(url, {
            method: 'POST',
            headers: {
                'Authorization' : authHeader.Authorization,
                'Content-Type': 'application/json',
                "Accept": "application/json"
            },
            body: JSON.stringify(user)            
        })
        .then(response => {
            console.log(`response = ${response}`);
            response.json();            
        })
        .then(data => {
            return data;
        }).catch((err) => {
            
            if(_.isEmpty(err)){
                return Promise.resolve({
                    error: 'No error!'
                });                    

            }else {
                return Promise.reject({
                    error: 'Error with service'
                });
            }

        });         
    }       

    static updateInsuredUser(user,authHeader = {}) {        
        let url = getProxiedUrl('ri-rest-services/api/ph/v1/ldap-user');

        return fetch(url, {
            method: 'PUT',
            headers: {
                'Authorization' : authHeader.Authorization,
                'Content-Type': 'application/json',
                "Accept": "application/json"
            },
            body: JSON.stringify(user)            
        })
        .then(response => response.json())
        .then(data => {
            return data;
        }).catch((err) => {
            
            if(_.isEmpty(err)){
                return Promise.resolve({
                    error: 'No error!'
                });                    

            }else {
                return Promise.reject({
                    error: 'Error with service'
                });
            }

        });         
    }      

    static deleteInsuredUser(userId,authHeader = {}) {
        let url = getProxiedUrl('ri-rest-services/api/ph/v1/ldap-user');

        return fetch(url, {
            method: 'DELETE',
            headers: {
                'Authorization' : authHeader.Authorization,
                'Content-Type': 'application/json',
                "Accept": "application/json"
            }       
        })
        .then(response => {
            console.log(`response = ${response}`);
            response.json();            
        })
        .then(data => {
            return data;
            
        }).catch((err) => {
            
            if(_.isEmpty(err)){
                return Promise.resolve({
                    error: 'No error!'
                });                    

            }else {
                return Promise.reject({
                    error: 'Error with service'
                });
            }

        });         

    }    // ----- FB 17118	
}
